import React, {useCallback, useEffect, useMemo, useState} from "react";
import axios from "axios";
import "./AddDocumentToCase.css";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CaseFilesInternal from "../../../enums/CaseFilesInternal";
import {IoIosCloseCircle} from "react-icons/io";
import CaseFilesStatus from "../../../enums/CaseFilesStatus";
import CaseFileDeclined from "../../../enums/CaseFileDeclined";
import {Button, Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select, Tooltip} from "@mui/material";
import {useLocation} from "react-router-dom";
import DocTypesEnum from "../../../enums/DocTypesEnum";
import JoditEditor from "jodit-react";
import CaseNotificationEnum from "../../../enums/CaseNotiFicationEnum";
import {jwtDecode} from "jwt-decode";
import DatePicker from "react-datepicker";
import {ka} from "date-fns/locale";
import nomenclatureEnum from "../../../enums/nomenclatureEnum";
import nomenclatureTitlesEnum from "../../../enums/nomenclatureTitlesEnum";
import orderDecisionEnum from "../../../enums/orderDecisionEnum";
import htmlEnums from "../../../enums/htmlEnums";
import TemplateEnum from "../../../enums/templateEnum";
import {debounce} from "lodash";
import {formatHtmlForEditor} from "../../../components/globalFunctions/globalFunctions";
import dummyFiles from "./base64";
import {AiOutlineCheckCircle} from "react-icons/ai";


const AddDocumentToCase = ({
                               onFileAdded,
                               buttonTitle,
                               docType,
                               userId,
                               barcode,
                               objectOwner,
                               disabledBecauseOfDeclinedFiles = false,
                               caseData,
                               isExtentionAttachment = false,
                               caseInfo,
                               users,
                               additionalInternalDocumentation = null,
                               hasOrderDate,
                               orderDepartment,
                               orderExists = false,
                               isSecretOrder = false,
                               isFileCancelRequestBuilding = false,
                               permitTypeTitle,
                               ownerIdentificationTemplateString,
                               exploitationIdentificationTemplateString,
                               disabledBecauseSecretOrderExist,
                               userAddress

                           }) => {
    const [title, setTitle] = useState("");
    const [isShared, setIsShared] = useState(false);
    const [isSharedExpertFile, setIsSharedExpertFile] = useState(false);
    const [declineStatus, setDeclineStatus] = useState(CaseFileDeclined.No);
    const [documentType, setDocumentType] = useState("");
    const [extraDescription, setExtraDescription] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editorContent, setEditorContent] = useState(docType.textHTML ? docType.textHTML : '');
    const [closing, setClosing] = useState(false);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [previewContent, setPreviewContent] = useState('');
    const [headerContent, setHeaderContent] = useState('');
    const isSubmitDisabled = !title || isEditorContentEmpty(editorContent) || !documentType || loading;
    const isSubmitDisabledForExplotion = !title || isEditorContentEmpty(editorContent) || !documentType || loading
    const [approvalDocument, setApprovalDocument] = useState(false);
    const [fontFamily, setFontFamily] = useState('Sylfaen');
    const [documentId, setDocumentId] = useState('');
    const [docPrefix, setDocPrefix] = useState(null);
    const location = useLocation();
    const caseId = new URLSearchParams(location.search).get('id');
    const [closeModalOn, setCloseModalOn] = useState(false);
    const [roleId, setRoleId] = useState("");
    const [orderDateDeadline, setOrderDateDeadline] = useState(null);
    const hasOrderDateBuilding = hasOrderDate && docType.documentTypeStatus === 1
    const isSubmitDisabledForBuilding = !title || isEditorContentEmpty(editorContent) || !documentType || loading || (docType.orderDecision !== 2 && !orderDateDeadline);
    const [mainUserId, setMainUserId] = useState("");
    const [debouncedContent, setDebouncedContent] = useState(editorContent);
    const [htmlLoaded, setHtmlLoaded] = useState(false);
    const [hideCase, setHideCase] = useState(false);


    useEffect(() => {
        if (htmlEnums && Object.keys(htmlEnums).length > 0) {
            setHtmlLoaded(true);
        }
    }, []);

    const uploadFileToGetDocumentNumber = async () => {

        const file = {
            caseID: parseInt(caseId),
            name: "test",
            ext: "pdf",
            file: dummyFiles.dummy,
            mainInfo: "",
            additionalInfo: "",
            shared: true,
            blank: false,
            documentType: 0,
            internal: CaseFilesInternal.No,
            status: CaseFilesStatus.Sent,
            decline: CaseFileDeclined.No,
            declinedInternalStatus: 0,
        }


        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, file);

        const caseFilesResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllCaseFileByCaseID?CaseId=${caseId}`);

        const caseFiles = caseFilesResponse.data.data.resultItems

        const caseFile = caseFiles.find(file => file.id === parseInt(response.data.resultId))

        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeleteCaseFile`, {caseFileId: response.data.resultId})

        return caseFile.documentNumber;

    }


    const debouncedUpdatePreview = useCallback(debounce(newContent => {
        setDebouncedContent(newContent);
    }, 50), []);

    useEffect(() => {
        debouncedUpdatePreview(editorContent);
    }, [editorContent, debouncedUpdatePreview]);

    const PdfPreviewContent = useMemo(() => {
        return (
            <div className="pdf-preview-container" style={{fontFamily}}>
                <Button
                    variant="contained"
                    color="primary"
                    style={{marginBottom: 28}}
                    startIcon={<AiOutlineCheckCircle/>}
                >
                    ცვლილების ნახვა
                </Button>
                <div id="pdf-page" className="pdf-page" style={{fontFamily}}>
                    <div dangerouslySetInnerHTML={{__html: headerContent}}/>
                    <div dangerouslySetInnerHTML={{__html: previewContent}}/>
                    <div style={{marginTop: 10}}
                         dangerouslySetInnerHTML={{__html: debouncedContent}}/>
                </div>
            </div>
        );
    }, [fontFamily, previewContent, debouncedContent, headerContent]);


    useEffect(() => {
        if (orderDepartment) {
            if (orderDepartment === nomenclatureEnum.building) {
                setDocPrefix(nomenclatureTitlesEnum.building)
            } else if (orderDepartment === nomenclatureEnum.explosion) {
                setDocPrefix(nomenclatureTitlesEnum.explosion)
            } else if (orderDepartment === nomenclatureEnum.registery) {
                setDocPrefix(nomenclatureTitlesEnum.registery)
            } else {
                setDocPrefix('')
            }
        }
    }, [orderDepartment]);

    useEffect(() => {
        const token = localStorage.getItem("jwtTokenMain");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setMainUserId(decoded.UserId);
            } catch (error) {
                setRoleId("");
            }
        }
    }, []);
    useEffect(() => {
        if (showPopup) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [showPopup]);

    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
            } catch (error) {
                setRoleId("");
            }
        }
    }, []);

    const sendNotification = async (fileId) => {
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const caseNotification = {
            nextStepUserId: roleId === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: fileId,
            action: CaseNotificationEnum.createdFile.id,
            caseStatus: 8,
            viewed: true,

        };

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };

    const georgianTranslations = {
        "Type something": " ",
        "Bold": "ტექსტის გამუქება",
        "Italic": "დახრილი ტექსტის შექმნა",
        "Underline": "ტექსტის ხაზგასმა",
        "Insert Image": "სურათის ჩასმა",
        "Clear Formatting": "ფორმატირების წაშლა",
        "Insert Format Block": "ფორმატირების ბლოკის ჩასმა",
        "Strike through": "გადახაზული",
        "Insert Unordered List": "ბურთულებიანი სიის შექმნა",
        "Insert Ordered List": "დანომრილი სიის შექმნა",
        "Font family": "შრიფტის არჩევა",
        "Font size": "შრიფტის ზომა",
        "Line height": "ხაზის დაშორება",
        "Insert Horizontal Line": "ხაზის დაშორება",
        "Increase Indent": "დაშორების გაზრდა",
        "Decrease Indent": "დაშორების შემცირება",
        "Undo": "უკუსვლა",
        "Redo": "საწყისი",
        "Align": "სწორება",
        "Insert Special Character": "სპეც. სიმბოლო",
        "Fill color or set the text color": "ფერის შეცვლა",
        "Background": "ფონი",
        "Text": "ტექსტი",
        "Insert format block": "ფორმატირება",
        "Print": "დაბეჭვდა",
        "Show all": "მეტის ნახვა",
        "Insert link": "ბმლის ჩასმა",
        "URL": "ბმული",
        "Open in new tab": "ახალ გვერდზე გახსნა",
        "Insert": "ჩასმა"
    };

    const mapFontFamilyToStyles = (fontName) => {
        const fontStyles = {
            'Arial': {
                fontFamily: 'arial_geo',
                bold: 'arial_geo-bold',
                italics: 'arial_geo-italic',
                bolditalics: 'arial_geo-bold-italic'
            },
            'Sylfaen': {
                fontFamily: 'sylfaen',
                bold: 'arial_geo-bold',
                italics: 'arial_geo-italic',
                bolditalics: 'arial_geo-bold-italic'
            }
        };
        return fontStyles[fontName] || fontStyles['Arial'];
    };


    const editorConfig = useMemo(() => ({
        readonly: false,
        toolbarButtonSize: "middle",
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        language: 'ka',
        i18n: {
            ka: georgianTranslations,
        },
        style: {
            fontFamily: mapFontFamilyToStyles(fontFamily).fontFamily,
        },
        height: 800,
        disablePlugins: [
            'spellcheck',
            'speech-recognize',
            'open-in-fullsize',
            'add-new-line',
            'Insert-file',
            'ai-assistant',
            'file',
            'image',
            'video',
            'fullsize',
            'about',
            'preview',
            'symbols',
            'symbol',
        ],
        controls: {
            font: {
                list: {
                    'Arial': 'Arial',
                    'Sylfaen': 'Sylfaen'
                }
            }
        },
        buttons: ["bold", "italic", "underline", "|", "subscript", "superscript"]

    }), []);


    useEffect(() => {
        const styleSheet = document.createElement('style');
        styleSheet.type = 'text/css';
        styleSheet.innerText = `
        .jodit-container * {
            font-family: ${mapFontFamilyToStyles(fontFamily).fontFamily} !important;
        }
    `;
        document.head.appendChild(styleSheet);

        return () => {
            document.head.removeChild(styleSheet);
        };
    }, [fontFamily]);

    const preprocessHtmlForPdf = (html, docNumber) => {
        const container = document.createElement('div');
        container.innerHTML = html.replace('{დოკუმენტის ნომერი}', "№ " + docNumber);
        const elementsWithStyle = container.querySelectorAll('[style]');
        elementsWithStyle.forEach(element => {
            const style = element.style;
            if (style.fontSize && isNaN(parseFloat(style.fontSize))) {
                style.fontSize = '16px';
            }
            if (style.textDecoration === 'none') {
                style.textDecoration = '';
            }
        });

        return container.innerHTML;
    };


    useEffect(() => {
        const fetchAndSetBarcode = async () => {
            if (docType && htmlLoaded) {
                setDocumentType(docType.documentTypeStatus);
                setTitle(docType.name);
                const docTypeEnumArray = Object.values(DocTypesEnum);
                const matchedDocType = docTypeEnumArray.find(dt => dt.id === docType.documentTypeStatus);
                if (matchedDocType) {
                    setIsShared(matchedDocType.shared);
                    setApprovalDocument(matchedDocType.approvalDocument);
                    if (matchedDocType.id === 13) {
                        setIsSharedExpertFile(true)
                        setDeclineStatus(CaseFileDeclined.ExpertDoc)
                    }
                    if (matchedDocType.id === 20) {
                        setDeclineStatus(CaseFileDeclined.secretDocument)
                    }
                    if (matchedDocType.id === 14) {
                        setDeclineStatus(CaseFileDeclined.ExpertDoc)
                    }
                    if (matchedDocType.id === 16) {
                        setDeclineStatus(CaseFileDeclined.RequireCaseCancellationBuildingAnswer)
                    }
                    if (matchedDocType.id === 18) {
                        setDeclineStatus(CaseFileDeclined.acceptRemoveFromRegistery)
                    }
                    if (matchedDocType.id === 19) {
                        setDeclineStatus(CaseFileDeclined.declineRemoveFromRegistery)
                    }

                } else {
                    setIsShared(false);
                    setApprovalDocument(false);
                }
                let blankHtmlContent = docType.blank;
                const barcodeImageBase64 = barcode;
                if (barcodeImageBase64 && docType.templateType !== TemplateEnum.insideLetter) {
                    blankHtmlContent = insertBarcodeIntoContent(barcodeImageBase64, blankHtmlContent);
                } else if (barcodeImageBase64 && docType.templateType === TemplateEnum.insideLetter) {
                    blankHtmlContent = insertBarcodeIntoContentForInsideLetter(barcodeImageBase64, blankHtmlContent)
                }
                setPreviewContent(blankHtmlContent);
                if (docType.templateType !== null) {
                    if (docType.templateType === TemplateEnum.order) {
                        setHeaderContent(htmlEnums.order)
                    } else if (docType.templateType === TemplateEnum.letter) {
                        setHeaderContent(htmlEnums.letter)
                    }

                }
            }
        };

        void fetchAndSetBarcode();
    }, [docType, htmlLoaded]);


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && showPopup) {
                if (!closeModalOn) {
                    setCloseModalOn(true);
                } else {
                    handleClosePopup();
                }
            }
        };


        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [closeModalOn]);


    const replacePlaceholders = (htmlContent) => {
        let createDate
        const date = new Date(caseInfo.createDate);
        if (isNaN(date)) {
            createDate = 'caseDate';
        } else {
            createDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`
        }

        const signeeUser = users.find(user => user.roleName === "HeadOfAgency")
        const userName = users.find(user => user.id === userId)
        const mainUserName = users.find(user => user.id === mainUserId)
        if (userId === mainUserId) {
            return htmlContent
                .replace(/\$requesterName\$/g, userName.firstName + ' ' + userName.lastName)
                .replace(/\$receiverName\$/g, objectOwner ? objectOwner : "")
                .replace(/\$signee\$/g, signeeUser.firstName + ' ' + signeeUser.lastName)
                .replace(/\$caseDate\$/g, createDate)
                .replace(/\$address\$/g, userAddress)
                .replace(/\$permitType\$/g, permitTypeTitle)
                .replace(/\$objectName\$/g, caseInfo.request)
                .replace(/\$objectOwnerIdentificationNumber\$/g, ownerIdentificationTemplateString)
                .replace(/\$exploitationIdentificationNumber\$/g, exploitationIdentificationTemplateString)
                .replace(/\$caseNumber\$/g, caseInfo.caseNumber.toString())
        } else {
            return htmlContent
                .replace(/\$requesterName\$/g, userName.firstName + ' ' + userName.lastName + "(-ის) მოვალეობის შემსრულებელი " + mainUserName.firstName + ' ' + mainUserName.lastName)
                .replace(/\$receiverName\$/g, objectOwner ? objectOwner : "")
                .replace(/\$signee\$/g, signeeUser.firstName + ' ' + signeeUser.lastName)
                .replace(/\$caseDate\$/g, createDate)
                .replace(/\$address\$/g, userAddress)
                .replace(/\$permitType\$/g, permitTypeTitle)
                .replace(/\$objectName\$/g, caseInfo.request)
                .replace(/\$objectOwnerIdentificationNumber\$/g, ownerIdentificationTemplateString)
                .replace(/\$exploitationIdentificationNumber\$/g, exploitationIdentificationTemplateString)
                .replace(/\$caseNumber\$/g, caseInfo.caseNumber.toString())
        }
    };

    useEffect(() => {
        if (docType.textHTML && mainUserId) {
            const updatedContent = replacePlaceholders(docType.textHTML);
            setEditorContent(updatedContent);
        }
    }, [docType.textHTML, mainUserId]);

    const resetForm = () => {
        setTitle("");
        setEditorContent("");
        setExtraDescription("");
        setDocumentType("");
        setIsShared(false);
    };


    function isEditorContentEmpty(content) {
        return !content.replace(/<[^>]*>/g, '').trim();
    }

    const insertBarcodeIntoContent = (base64ImageData, htmlContent) => {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = htmlContent

        const table = document.createElement('table')
        table.style.width = '100%'
        table.style.borderCollapse = 'collapse'
        table.style.border = 'none'

        const headerRow = document.createElement('tr')

        const dateTableCell = document.createElement('td')
        dateTableCell.style.verticalAlign = 'middle'
        dateTableCell.style.border = 'none'
        dateTableCell.style.padding = '0'
        dateTableCell.style.color = 'black'
        dateTableCell.style.fontFamily = 'Sylfaen'
        dateTableCell.style.fontSize = '20px'
        dateTableCell.textContent = '{ხელმოწერის თარიღი}'

        headerRow.appendChild(dateTableCell)

        const barcodeTableCell = document.createElement('td')
        barcodeTableCell.style.verticalAlign = 'middle'
        barcodeTableCell.style.textAlign = 'right'
        barcodeTableCell.style.border = 'none'
        barcodeTableCell.style.padding = '0'

        const barcodeContainer = document.createElement('div')

        const barcodeImage = document.createElement('img')
        barcodeImage.src = base64ImageData
        barcodeImage.style.width = '200px'
        barcodeImage.style.height = '50px'

        barcodeContainer.appendChild(barcodeImage)

        const generateRandomNumberString = length => {
            let generatedValue = ''
            for (let index = 0; index < length; index++) {
                generatedValue += Math.floor(Math.random() * 10)
            }
            return generatedValue
        }

        const barcodeText = 'KA' + generateRandomNumberString(15)

        const barcodeTextDiv = document.createElement('div')
        barcodeTextDiv.style.fontSize = '14px'
        barcodeTextDiv.style.color = 'black'
        barcodeTextDiv.style.fontFamily = 'Sylfaen'
        barcodeTextDiv.textContent = barcodeText

        barcodeContainer.appendChild(barcodeTextDiv)
        barcodeTableCell.appendChild(barcodeContainer)

        headerRow.appendChild(barcodeTableCell)
        table.appendChild(headerRow)

        const documentRow = document.createElement('tr')

        const documentNumberCell = document.createElement('td')
        documentNumberCell.style.verticalAlign = 'middle'
        documentNumberCell.style.border = 'none'
        documentNumberCell.style.padding = '0'
        documentNumberCell.style.paddingTop = '50px'

        const documentNumberDiv = document.createElement('div')
        documentNumberDiv.textContent = '{დოკუმენტის ნომერი}'
        documentNumberDiv.style.fontSize = '18px'
        documentNumberDiv.style.color = 'black'
        documentNumberDiv.style.fontFamily = 'Sylfaen'

        documentNumberCell.appendChild(documentNumberDiv)

        const emptyCell = document.createElement('td')
        emptyCell.style.border = 'none'
        emptyCell.style.padding = '0'

        documentRow.appendChild(documentNumberCell)
        documentRow.appendChild(emptyCell)

        table.appendChild(documentRow)

        tempDiv.appendChild(table)
        return tempDiv.innerHTML
    }


    const insertBarcodeIntoContentForInsideLetter = (base64ImageData) => {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = '<div></div>'

        const contentContainer = document.createElement('div')
        contentContainer.style.position = 'relative'
        contentContainer.style.width = '100%'
        contentContainer.style.textAlign = 'right'

        tempDiv.appendChild(contentContainer)

        const barcodeImage = document.createElement('img')
        barcodeImage.src = base64ImageData
        barcodeImage.style.width = '150px'
        barcodeImage.style.height = '30px'

        contentContainer.appendChild(barcodeImage)

        const insideLetterDiv = document.createElement('div')
        insideLetterDiv.innerHTML = htmlEnums.insideLetter
        insideLetterDiv.style.marginTop = '10px'
        insideLetterDiv.style.textAlign = 'center'

        contentContainer.appendChild(insideLetterDiv)

        const dateSpan = document.createElement('span')
        dateSpan.textContent = "{ხელმოწერის თარიღი}"
        dateSpan.style.fontSize = '18px'
        dateSpan.style.color = 'black'
        dateSpan.style.marginRight = '15px'
        dateSpan.style.fontFamily = 'Sylfaen'
        dateSpan.style.letterSpacing = '-0.5px'

        contentContainer.appendChild(dateSpan)

        return tempDiv.innerHTML
    }


    const handleClosePopup = () => {
        setCloseModalOn(false)
        setShowPopup(false);
        setClosing(false);
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        setIsConfirmModalOpen(true);
    };

    const handleFontChange = (e) => {
        setFontFamily(e.target.value);
    };


    const handleConfirmSubmit = async () => {
        setIsConfirmModalOpen(false);
        setLoading(true);

        const fileNumber = await uploadFileToGetDocumentNumber();

        const forceFontFamily = (htmlContent) => {
            const installedFonts = ["Sylfaen", "Arial", "DejaVu"];

            const container = document.createElement('div');
            container.innerHTML = htmlContent;
            Array.from(container.querySelectorAll("*")).forEach(el => {
                const currentFont = window.getComputedStyle(el).fontFamily.split(',')[0].replace(/['"]/g, '').trim();
                if (!installedFonts.includes(currentFont)) {
                    el.style.fontFamily = fontFamily;
                }
            });
            return container.innerHTML;
        };

        const updatedPreviewContent = forceFontFamily(previewContent.replace(/background-color:\s*transparent;\s*/g, ''));
        const updatedEditorContent = forceFontFamily(editorContent.replace(/background-color:\s*transparent;\s*/g, ''));

        setPreviewContent(updatedPreviewContent);
        setEditorContent(updatedEditorContent);


        const processedContent = preprocessHtmlForPdf(`<div style="font-family: ${fontFamily}">${headerContent}${updatedPreviewContent}${updatedEditorContent}</div>`, fileNumber + docPrefix);

        const processedHtml = formatHtmlForEditor(processedContent, fontFamily);


        const requestBody = {
            caseID: parseInt(caseId),
            name: title,
            ext: 'pdf',
            mainInfo: processedHtml,
            additionalInfo: extraDescription,
            sharedTemp: isShared,
            shared: isSharedExpertFile,
            blank: true,
            documentType: documentType,
            internal: CaseFilesInternal.No,
            status: CaseFilesStatus.ReadyForVisage,
            decline: declineStatus,
            approvalDocument: approvalDocument,
            declinedInternalStatus: 0,
            activeUserId: userId,
            isExtentionAttachment: isExtentionAttachment,
            isExtentionAttachmentApprovedByHead: false,
            additionalInternalDocumentation: additionalInternalDocumentation,
            casefileNumber: fileNumber + docPrefix,
            termOfPermitDate: orderDateDeadline ? orderDateDeadline : null,
            isSecretDoc: !isSecretOrder ? null : hideCase ? 1 : 3,
            orderDecision: docType.orderDecision,
            html: processedHtml,
            isHTML: true,
            skipVisage: docType.skipVisage
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, requestBody);
            setDocumentId(response.data.resultId);

            resetForm();

        } catch (error) {
        } finally {
            setShowPopup(false);
            setLoading(false);

        }
    };

    useEffect(() => {
        const sendNotificationIfDocumentIdExists = async () => {
            if (documentId) {
                await sendNotification(documentId)
                onFileAdded();
            }
        };

        void sendNotificationIfDocumentIdExists();
    }, [documentId]);

    const handleDeclineReasonChangeBuilding = (e) => {
        setDeclineStatus(e.target.checked ? CaseFileDeclined.RequireCaseCancellationBuildingAnswer : CaseFileDeclined.RequireCaseCancellationBuildingAnswerDenied);
    };

    return (
        <>
            {mainUserId && (
                <div>
                    <Tooltip
                        title={disabledBecauseSecretOrderExist ? "დოკუმენტი უკვე არსებობს" : orderExists ? "სანებართვო მოწმობის შექმინსთვის ატვირთეთ ბრძანება!" : disabledBecauseOfDeclinedFiles ? "ბრძანების შექმნისთვის წაშალეთ დახარვეზების აქტი!" : ""}>
                        <span>
                            <button
                                className={"document-button"}
                                onClick={() => {
                                    setShowPopup(true);
                                }}
                                disabled={loading || orderExists || disabledBecauseOfDeclinedFiles || disabledBecauseSecretOrderExist}
                            >
                                {loading ? "იტვირთება..." : buttonTitle}
                            </button>
                        </span>
                    </Tooltip>
                    {showPopup && (
                        <div className="overlay" onClick={() => setCloseModalOn(true)}></div>
                    )}
                    {showPopup && (
                        <div className={`custom-scrollbar popup-editor ${closing ? 'popup-closing' : ''}`}>
                            {loading ? (
                                <div className="loader"></div>
                            ) : (
                                <div className="editor-and-preview-container">
                                    <div>
                                        <form onSubmit={handleSubmit}>
                                            <input
                                                type="text"
                                                value={title}
                                                onChange={(e) => setTitle(e.target.value)}
                                                placeholder="სათაური"
                                                className={"add-doc-input"}
                                            />
                                            {hasOrderDateBuilding && docType.orderDecision === orderDecisionEnum.Approve.id && (
                                                <div style={{marginBottom: 10}}>
                                                    <label style={{marginRight: 10}}>ნებართვის ვადა:</label>
                                                    <DatePicker
                                                        selected={orderDateDeadline}
                                                        onChange={(date) => setOrderDateDeadline(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        minDate={new Date()}
                                                        locale={ka}
                                                        showYearDropdown
                                                        scrollableYearDropdown
                                                        showMonthDropdown
                                                        placeholderText="აირჩიეთ თარიღი"
                                                    />
                                                </div>
                                            )}

                                            <div className="q-editor-container">
                                                <FormControl fullWidth style={{marginBottom: 8}}>
                                                    <InputLabel id="font-family-label">შრიფტი</InputLabel>
                                                    <Select
                                                        labelId="font-family-label"
                                                        value={fontFamily}
                                                        label="შრიფტი"
                                                        onChange={handleFontChange}
                                                        sx={{backgroundColor: 'white', borderRadius: 1}}
                                                    >
                                                        <MenuItem value="DejaVu">DejaVu Sans</MenuItem>
                                                        <MenuItem value="Sylfaen">Sylfaen</MenuItem>

                                                    </Select>
                                                </FormControl>

                                                <JoditEditor
                                                    key={fontFamily}
                                                    value={editorContent}
                                                    config={editorConfig}
                                                    tabIndex={1}
                                                    onBlur={newContent => setEditorContent(newContent)}
                                                />
                                                {isSecretOrder && (
                                                    <FormControlLabel
                                                        control={<Checkbox checked={hideCase} onChange={(e) => setHideCase(e.target.checked)}/>}
                                                        label="განაცხადის დამალვა"
                                                    />
                                                )}


                                            </div>
                                            <textarea
                                                value={extraDescription}
                                                onChange={(e) => setExtraDescription(e.target.value)}
                                                placeholder="დამატებითი აღწერა"
                                                style={{
                                                    width: "99.39%",
                                                    height: "200px",
                                                    resize: "vertical",
                                                    margin: "10px 0",
                                                }}
                                            />


                                            {isFileCancelRequestBuilding && (
                                                <div className="doc-checkbox-container">
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={declineStatus === CaseFileDeclined.RequireCaseCancellationBuildingAnswer}
                                                                onChange={handleDeclineReasonChangeBuilding}
                                                                name="declineReason"
                                                                color="primary"
                                                            />
                                                        }
                                                        label="განუხილველად დატოვება"
                                                    />
                                                </div>
                                            )}

                                            <Tooltip title={isSubmitDisabledForExplotion ? "შეავსეთ ყველა ველი" : ""}>
                                                {caseData && caseData.needApprovalDocument && approvalDocument ? (
                                                    <button
                                                        type="submit"
                                                        style={{
                                                            backgroundColor: isSubmitDisabledForExplotion ? '#ccc' : '#2E76E4',
                                                            color: isSubmitDisabledForExplotion ? '#666' : 'white',
                                                            cursor: isSubmitDisabledForExplotion ? 'not-allowed' : 'pointer'
                                                        }}
                                                        className="doc-submit-button"
                                                        disabled={isSubmitDisabledForExplotion}
                                                    >
                                                        დოკუმენტის შექმნა
                                                    </button>
                                                ) : hasOrderDateBuilding ? (
                                                        <button
                                                            type="submit"
                                                            style={{
                                                                backgroundColor: isSubmitDisabledForBuilding ? '#ccc' : '#2E76E4',
                                                                color: isSubmitDisabledForBuilding ? '#666' : 'white',
                                                                cursor: isSubmitDisabledForBuilding ? 'not-allowed' : 'pointer'
                                                            }}
                                                            className="doc-submit-button"
                                                            disabled={isSubmitDisabledForBuilding}
                                                        >
                                                            დოკუმენტის შექმნა
                                                        </button>
                                                    )

                                                    : (
                                                        <button
                                                            type="submit"
                                                            style={{
                                                                backgroundColor: isSubmitDisabled ? '#ccc' : '#2E76E4',
                                                                color: isSubmitDisabled ? '#666' : 'white',
                                                                cursor: isSubmitDisabled ? 'not-allowed' : 'pointer'
                                                            }}
                                                            className="doc-submit-button"
                                                            disabled={isSubmitDisabled}
                                                        >
                                                            დოკუმენტის შექმნა
                                                        </button>
                                                    )}

                                            </Tooltip>
                                        </form>
                                    </div>
                                    {PdfPreviewContent}
                                </div>
                            )}
                            <IoIosCloseCircle className="upload-single-close-icon-text-editor"
                                              onClick={() => setCloseModalOn(true)}
                            />
                            <ConfirmationModal
                                isOpen={isConfirmModalOpen}
                                onRequestClose={() => setIsConfirmModalOpen(false)}
                                onConfirm={handleConfirmSubmit}
                            />
                            <ConfirmationModal
                                isOpen={closeModalOn}
                                onRequestClose={() => setCloseModalOn(false)}
                                onConfirm={handleClosePopup}
                                modalText={"დახურვის შემთხვევაში წაიშლება პროგრესიც!"}
                            />
                        </div>
                    )}
                    {loading && <div className="loader"></div>}
                </div>
            )
            }
        </>

    );
};

export default AddDocumentToCase;
